<template>
  <div class="notOut" @click="removeAll()">
    <!-- 待支付侧边栏 -->
    <div class="leftTip" v-if="ISnoData">
      <div class="text">未出累计金额 (元)</div>
      <div class="num">
        <p style="font-size:35px" v-html="sidebar.unRefundAmountNew1">{{ sidebar.unRefundAmountNew1}}</p>
      </div>
      <div class="line"></div>
      <div class="gray-word">运单数：</div>
      <div class="text2">{{ sidebar.total || 0 }}</div>
      <div class="gray-word hint">
        <span>提前生成账单，请联系</span>
        <el-popover
          placement="bottom-start"
          width="220"
          trigger="hover"
          v-model="ISAccountingPhone"
        >
          <div class="">会计电话：{{ AccountingPhone }}</div>
          <span
            class="phone bgc-blue"
            @click="AccountingPhoneRequest"
            slot="reference"
            >对账会计</span
          >
        </el-popover>
      </div>
    </div>
    <!-- 中间内容 -->
    <div class="content" v-if="ISnoData">
      <!-- 选择器 & 按钮 头部筛选 -->
      <div class="title">
        <div class="df">
          <div class="flex1 mainTop">
            <div class="showcase" @click.stop="batchs()">
              <el-input
                placeholder="搜索运单, 支持批量搜索"
                v-model="waybillNumbers"
                class="input-with-select"
                size="mini"
              >
              </el-input>
            </div>
            <div class="batchInput" v-show="batchShow" @click.stop="">
              <el-input
                ref="input"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 10 }"
                placeholder="请输入德邦运单号，最多支持10条数据查询，请使用英文逗号、空格键或回车键分隔！"
                v-model="waybillNumbers"
                @blur="fun()"
              >
              </el-input>
              <div class="batchSearch">
                <el-button
                  @click.stop="searchs('搜索')"
                  size="small"
                  type="primary"
                  plain
                  >搜索</el-button
                >
              </div>
            </div>
          </div>
          <div class="flex1 seldate">
            运单时间：
            <el-date-picker
              v-model="timeQuantum"
              type="daterange"
              size="mini"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :clearable="false"
            >
            </el-date-picker>
          </div>
        </div>

        <div class="btn df">
          <span class="b1" style="margin-right: 24px" @click="EmptyFilter">清空筛选</span>
          <div class="b2" style="color: white" @click.stop="searchs('筛选')">
            筛选
          </div>
        </div>
      </div>
      <div class="main">
        <p id="outPut" style="text-align: right">
          <el-button
            type="primary"
            size="small"
            :loading="downloadLoading"
            @click="derivedData"
            >导出</el-button
          >
        </p>

        <div class="tableTiele">
          <div class="setup" @click.stop="titShow">列表字段筛选</div>
          <div class="titName" v-show="tableShow" @click.stop="tableShow = true">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <!-- <div
                style="
                  margin: 5px 0;
                  width: 100%;
                  height: 1px;
                  background: #ccc;
                "
              ></div> -->
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="city in cities"
                :label="city"
                :key="city"
                :disabled="checkedCitiesDisable.includes(city)"
                >{{ city }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <div style="max-height: 900px" class="tables" :style="widths" ><!--style="max-height: 1000px"-->
          <el-table :data="tableData" style="width: 100%" height="100%">
            <el-table-column fixed label="序号" align="center" width="48">
              <template slot-scope="scope">
                <!-- 这里暂时写为 默认 index值, 需要后期与接口联动 , <当前页> 和 <x条/页> -->
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="date"
              label="运单号"
              width="189"
              v-if="checkedCities.includes('运单号')"
            >
              <template slot-scope="scope">
                <span class="bgc-blue ">{{ scope.row.sourceBillNo }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="businessDate"
              width="100"
              label="业务日期"
              v-if="checkedCities.includes('业务日期')"
            >
            </el-table-column>
            <el-table-column
              prop="productType"
              label="产品类型"
              width="100"
              v-if="checkedCities.includes('产品类型')"
            >
              <template slot-scope="scope">
                <span
                  class="text-hidden pointer"
                  :title="scope.row.productType"
                  >{{ scope.row.productType }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="deliveryStation"
              label="始发站"
              width="100"
              v-if="checkedCities.includes('始发站')"
            >
              <template slot-scope="scope">
                <span
                  :title="scope.row.deliveryStation"
                  class="text-hidden pointer"
                  >{{ scope.row.deliveryStation }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="destination"
              label="目的地"
              width="200"
              v-if="checkedCities.includes('目的地')"
            >
              <template slot-scope="scope">
                <span
                  class="text-hidden pointer altitude"
                  :title="scope.row.destination"
                  >{{ scope.row.destination }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="consignorContacts"
              label="发货人"
              width="100"
              v-if="checkedCities.includes('发货人')"
            >
              <template slot-scope="scope">
                <span
                  class="text-hidden pointer"
                  :title="scope.row.consignorContacts"
                  >{{ scope.row.consignorContacts }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="consignee"
              label="收货人"
              width="100"
              v-if="checkedCities.includes('收货人')"
            >
              <template slot-scope="scope">
                <span
                  class="text-hidden pointer"
                  :title="scope.row.consignee"
                  >{{ scope.row.consignee }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="goodsName"
              label="货物名称"
              width="100"
              v-if="checkedCities.includes('货物名称')"
            >
            </el-table-column>
            <el-table-column
              prop="pickupWay"
              label="提货方式"
              width="100"
              v-if="checkedCities.includes('提货方式')"
            >
            </el-table-column>
            <el-table-column
              prop="packageQuantity"
              label="件数"
              width="100"
              v-if="checkedCities.includes('件数')"
            >
            </el-table-column>
            <el-table-column
              prop="weight"
              label="重量"
              width="100"
              v-if="checkedCities.includes('重量')"
            >
            </el-table-column>
            <el-table-column
              prop="volume"
              label="体积"
              width="100"
              v-if="checkedCities.includes('体积')"
            >
            </el-table-column>
            <el-table-column
              prop="chargeWeight"
              label="计费重量"
              width="100"
              v-if="checkedCities.includes('计费重量')"
            >
            </el-table-column>
            <el-table-column
              prop="publishFreinghtTax"
              label="公布价运费"
              width="100"
              v-if="checkedCities.includes('公布价运费')"
            >
            </el-table-column>
            <el-table-column
              prop="insuranceStatement"
              label="保价"
              width="100"
              v-if="checkedCities.includes('保价')"
            >
            </el-table-column>
            <el-table-column
              prop=" insuranceFee"
              label="保价费"
              width="100"
              v-if="checkedCities.includes('保价费')"
            >
            </el-table-column>
            <el-table-column
              prop="packingFee"
              label="包装费"
              width="100"
              v-if="checkedCities.includes('包装费')"
            >
            </el-table-column>
            <el-table-column
              prop="resendFee"
              label="中转费"
              width="100"
              v-if="checkedCities.includes('中转费')"
            >
            </el-table-column>
            <el-table-column
              prop="codAmount"
              label="代收货款金额"
              width="120"
              v-if="checkedCities.includes('代收货款金额')"
            >
            </el-table-column>
            <el-table-column
              prop="collectionChargesPoundage"
              label="代收货款手续费"
              width="120"
              v-if="checkedCities.includes('代收货款手续费')"
            >
            </el-table-column>
            <el-table-column
              prop="amount"
              label="总金额"
              width="100"
              v-if="checkedCities.includes('总金额')"
            >
            </el-table-column>
            <el-table-column
              prop="unverifyAmount"
              label="未核销金额"
              width="200"
              v-if="checkedCities.includes('未核销金额')"
            >
            </el-table-column>

          </el-table>
        </div>
        <div class="bottom" v-if="isBottom">
          <el-pagination
            v-if="totalNumber > 10"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currpage"
            :page-sizes="[5, 10, 50]"
            :page-size="pagesize"
            layout="total,prev, pager, next, sizes,jumper"
            :total="totalNumber"
          >
            <!-- sidebar.wayBillTotal -->
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 没有数据展示 -->
    <div class="no-data" v-if="!ISnoData">
      <noContent
        explain="账单生成后我们将以短信的形式通知您，请耐心等待"
      ></noContent>
    </div>
  </div>
</template>
<script>
import API from "../../../api/bill";
import noContent from "@/components/noContent";
import moment from "moment";
const api = new API();
const cityOptions = [
  "公布价运费",
  "保价",
  "保价费",
  "包装费",
  "中转费",
  "代收货款金额",
  "代收货款手续费",
  // "序号",
  "业务日期",
  "运单号",
  "产品类型",
  "始发站",
  "目的地",
  "发货人",
  "收货人",
  "货物名称",
  "提货方式",
  "件数",
  "重量",
  "体积",
  "计费重量",
  "总金额",
  "未核销金额",
]; // 这里是表头展示的字段  ==>要与表格对应

const datesubtract = moment(new Date()).subtract(1, "months").valueOf(); // 获取 上月 时间戳
export default {
  components: { noContent },
  data() {
    return {
      // datesubtract:'',
      searchsTimeQuantum: [],
      searchsSourceBillNo: "",
      pickerOptions: {
        disabledDate(time) {
          return new Date() < time.getTime() || time.getTime() <= datesubtract;
        },
      },
      downloadLoading: false,
      ISnoData: true,
      ISAccountingPhone: false, //会计电话显示
      AccountingPhone: "95353", //会计电话
      filtrate: false,
      totalNumber: 0, //分页总条数
      isBottom: false,
      parme: {},
      item: {},
      timeQuantum: "", // 运单时间
      checkAll: false, // 全选默认值
      checkedCities: [
        // "序号",
        "业务日期",
        "运单号",
        "产品类型",
        "始发站",
        "目的地",
        "发货人",
        "收货人",
        "货物名称",
        "提货方式",
        "件数",
        "重量",
        "体积",
        "计费重量",
        "总金额",
        "未核销金额",
      ], // 勾选项 遍历勾选框   //==>默认禁用项, 填写禁用项
      cities: cityOptions,
      isIndeterminate: true,
      tableShow: false,
      batchShow: false,
      // waybillNumber: "", // 运单 搜素
      waybillNumbers: "", // 批量搜索 ===
      // strNew:'', //去除空格 和换行 的 运单号
      sidebar: {}, //侧边栏数据
      //  表格 数据 list
      tableData: [],
      pagesize: 10,
      currpage: 1, // 当前第几页
      screenWidth: document.body.clientWidth, // 监听 屏幕的宽度
    };
  },
  computed: {
    //  宽度样式:计算可视区宽度 返回表格的 宽度样式 // ====>(可视区变换表格宽度没继承 flex:1 的宽度)BUG 的优化 (++ 如果有更好的解决方法, 可以重写 ++)
    widths() {
      return { width: this.screenWidth - 300 + "px" };
    },
  },
  watch: {},
  methods: {
    // 导出
    derivedData() {
      if (this.timeQuantum !== "") {
        this.filtrate = true;
        this.timeQuantum[0] = this.$moment(this.timeQuantum[0]).format(
          "YYYY-MM-DD"
        );
        this.timeQuantum[1] = this.$moment(this.timeQuantum[1]).format(
          "YYYY-MM-DD"
        );
      }
      this.downloadLoading = true;
      this.printUnsettleTrade();
    },
    // 导出
    printUnsettleTrade() {
      let parme = {
        sourceBillNo: this.searchsSourceBillNo,
        tableColumns: this.checkedCities.toString(),
        startDate: this.searchsTimeQuantum[0],
        endDate: this.searchsTimeQuantum[1],
      };
      api.printUnsettleTrade(parme).then((res) => {
        this.downloadLoading = false;
        if (res) {
          let link = document.createElement("a");
          //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
          let blogw = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
          link.href = objectUrl;
          link.download = decodeURI(
            escape(
              res.headers["content-disposition"]
                .replace("attachment; filename=", "")
                .replace(new RegExp('"', "gm"), "")
            )
          ); //  下载的时候的文件名
          link.click();
          window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
          // this.downloadLoading = false
          this.$message({
            message: "导出成功",
            type: "success",
          });
        } else {
          // console.log("返回数据为空");
        }
      });
    },
    // 点击空白 清除所有无关弹框
    removeAll() {
      this.batchShow = false; // 点击空白 隐藏批量配置
      this.tableShow = false; // 点击空白 隐藏配置表头
    },
    batchs() {
      var tiems = "";
      tiems = setTimeout(() => {
        this.batchShow = true;
        clearTimeout(tiems);
      }, 100);
      // 使 输入框 获取焦点
      var tiems2 = "";
      tiems2 = setTimeout(() => {
        this.$refs.input.focus();
        clearTimeout(tiems2);
      }, 200);
    },
    strFil2(list, type) {
      let a = [];
      list.map((i) => {
        i.split(type).map((j) => {
          if (j) {
            a.push(j);
          }
        });
      });
      return a;
    },
    // 清空筛选
    EmptyFilter() {
      this.waybillNumbers = "";
      this.timeQuantum = "";
      this.searchs('筛选');
    },
    //批量搜索框失去焦点
    fun() {
      var temporary = this.waybillNumbers.split("\n");
      this.waybillNumbers = this.strFil2(
        this.strFil2(this.strFil2(temporary, "，"), " "),
        ","
      ).join();
    },
    // 搜索 筛选
    searchs(distinguish) {
      // this.searchsSourceBillNo =
      this.batchShow = false;
      var temporary = this.waybillNumbers.split("\n");
      //  temporary = this.waybillNumbers.split("\t");
      this.waybillNumbers = this.strFil2(
        this.strFil2(this.strFil2(temporary, "，"), " "),
        ","
      ).join();
      let strNewlist = this.strFil2(
        this.strFil2(this.strFil2(temporary, "，"), " "),
        ","
      );
      if (strNewlist.length > 10) {
        return this.$message.error(
          "只支持10条以内运单查询，请确认您输入的数据！"
        );
      }
      if (distinguish == "搜索" && this.waybillNumbers == "") {
        return this.$message.error("搜索不能为空！");
      }
      if (
        (this.waybillNumbers == "" && this.timeQuantum == "") ||
        this.timeQuantum == null
      ) {
        this.searchsTimeQuantum = this.timeQuantum;
        this.searchsSourceBillNo = this.waybillNumbers;
        return this.queryUnsettleTrade();
      }
      this.currpage = 1;
      this.pagesize = 10;
      //  this.waybillNumber = strNewlist[0]+'等'+strNewlist.length+'条数据'
      this.searchsTimeQuantum = this.timeQuantum;
      this.searchsSourceBillNo = this.waybillNumbers;
      this.queryUnsettleTradeSearch(distinguish);
    },
    // 分页 : 选择展示条数
    handleSizeChange(val) {
      this.pagesize = val;
      this.currpage = 1; // 切换 没有多少条的时候 重置为第1页开始
      this.filtrate
        ? this.queryUnsettleTradeSearch("筛选")
        : this.queryUnsettleTrade();
    },
    // 分页 : 换页
    handleCurrentChange(val) {
      this.currpage = val;
      this.filtrate
        ? this.queryUnsettleTradeSearch("筛选")
        : this.queryUnsettleTrade();
    },
    handleCheckAllChange(val) {
      //配置表头全选功能
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
      if (!val) {
        this.checkedCities = [
          "序号",
          "业务日期",
          "运单号",
          "产品类型",
          "始发站",
          "目的地",
          "发货人",
          "收货人",
          "货物名称",
          "提货方式",
          "件数",
          "重量",
          "体积",
          "计费重量",
          "总金额",
          "未核销金额",
        ];
      }
    },
    handleCheckedCitiesChange(val) {
      //配置表头单个勾选
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    titShow() {
      //弹出配置表头
      this.tableShow = !this.tableShow;
    },
    // 数据请求
    async queryUnsettleTrade() {
      this.isBottom = true;
      let parme = {
        currentPage: this.currpage,
        pageSize: this.pagesize,
      };
      let res = await api.queryUnsettleTrade(parme);
      if (res.dataList.length != 0) {
        this.sidebar = res;
        /*this.sidebar.unRefundAmountNew1 = (
          "" + this.sidebar.totalUnVerifyAmount
        ).split(".")[0];
        this.sidebar.unRefundAmountNew2 = (
          "" + this.sidebar.totalUnVerifyAmount
        ).split(".")[1];*/
        this.sidebar.unRefundAmountNew1 = this.separateNum(this.sidebar.totalUnVerifyAmount.toString());
        this.tableData = res.dataList;
        this.totalNumber = this.sidebar.total;
        this.tableData.forEach((item) => {
          item.businessDate = this.$moment(item.businessDate).format(
            "YYYY-MM-DD"
          );
        });
      } else {
        this.ISnoData = false;
      }

    }, separateNum(value) {
      console.info("test:"+ value);
      console.info("value.type:"+typeof value);
      if (!value) return "0.00";
      var intPart = Number(value).toFixed(0); //获取整数部分
      var intPartFormat = intPart
              .toString()
              .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
      var floatPart = ".00"; //预定义小数部分
      var value2Array = value.split(".");
      //=2表示数据有小数位
      var totalMoney;
      if (value2Array.length == 2) {
        floatPart =value2Array[1].toString(); //拿到小数部分
        if (floatPart.length == 1) {
          //补0,
          totalMoney=intPartFormat  + "." +  floatPart + '0';
          totalMoney = totalMoney.split(".");
          return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
        } else {
          totalMoney= intPartFormat + "." + floatPart;
          totalMoney = totalMoney.split(".");
          return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
        }
      } else {
        totalMoney= intPartFormat + floatPart;
        totalMoney = totalMoney.split(".");
        console.info("total:"+totalMoney);
        //this.unRefundAmountNew1=`${totalMoney[0]}.<span style="font-size:12px;">${totalMoney[1]}</span>`;
        return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
      }
    },
    // 搜索数据请求
    async queryUnsettleTradeSearch(distinguish) {
      let parme = {};
      if (distinguish == "筛选") {
        this.isBottom = true;
        if (this.timeQuantum !== "") {
          this.isBottom = true;
          this.filtrate = true;
          this.timeQuantum[0] = this.$moment(this.timeQuantum[0]).format(
            "YYYY-MM-DD"
          );
          this.timeQuantum[1] = this.$moment(this.timeQuantum[1]).format(
            "YYYY-MM-DD"
          );
          parme = {
            // statBillNo: this.item.statBillNo,
            startDate: this.timeQuantum[0],
            endDate: this.timeQuantum[1],
            sourceBillNo: this.waybillNumbers,
            currentPage: this.currpage,
            pageSize: this.pagesize,
          };
        } else {
          this.isBottom = true;
          parme = {
            statBillNo: this.item.statBillNo,
            sourceBillNo: this.waybillNumbers,
            currentPage: 1,
            pageSize: 10,
          };
        }
      } else {
        this.isBottom = false;
        parme = {
          statBillNo: this.item.statBillNo,
          sourceBillNo: this.waybillNumbers,
          currentPage: 1,
          pageSize: 10,
        };
      }
      let res = await api.queryUnsettleTrade(parme);
      if (res) {
        this.tableData = res.dataList;
        this.totalNumber = res.total;
        this.tableData.forEach((item) => {
          item.businessDate = this.$moment(item.businessDate).format(
            "YYYY-MM-DD"
          );
        });
      } else {
        this.tableData = "";
      }
    },
    async AccountingPhoneRequest() {
      let res = await api.getMonthCustomerLeader();
      if (res) {
        this.AccountingPhone = res.monthLeaderInfo.phone;
      }
    },
  },
  mounted() {
    // DOM渲染后 注册onresize事件 获取动态宽度 , 来解决 BUG(样式问题)
    const _that = this;
    window.onresize = () => {
      return (() => {
        _that.screenWidth = document.body.clientWidth;
      })();
    };
  },
  created() {
    this.queryUnsettleTrade();
    this.checkedCitiesDisable = JSON.parse(JSON.stringify(this.checkedCities)); // 初始化 禁用选项
  },
};
</script>

<style lang='less' scoped>
.notOut {
  display: flex;
  height: 100%;
  overflow: auto;
  font-size: 14px;
  .leftTip {
    border: 1px solid #ECECEC;
    background-color: #fff;
    width: 262px;
    height: 226px;
    margin-right: 6px;
    padding: 24px;
    text-align: left;
    .text {
      font-weight: 500;
      color: rgba(0, 0, 0, 0.88);
    }
    .num {
      span:nth-child(1) {
        font-size: 35px;
        font-weight: 500;
        line-height: 40px;
      }
      span:nth-child(2) {
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
      }
    }
    .line {
      margin: 22px 0 18px 0;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.08);
    }
    .text2 {
      color: rgba(0, 0, 0, 0.8);
      margin: 8px 0 16px;
    }
    .hint {
      font-size: 12px;
    }
    .phone {
      font-size: 13px;
      text-decoration: underline;
    }
  }
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .title {
      padding: 32px 24px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      .flex1 {
        // overflow: hidden;
        text-align: left;
        display: flex;
        align-items: center;
        color: #323233;
        width: 328px;
        position: relative;
      }
      .showcase {
        width: 328px;
      }
      .mainTop {
        .batchInput {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          /deep/.el-textarea textarea {
            padding-bottom: 50px;
          }
        }
        .batchSearch {
          z-index: 1111;
          position: absolute;
          bottom: 1px;
          right: 15px;
          text-align: right;
          width: 300px;
          background-color: #fff;
          padding: 5px 5px 15px 5px;
          .searchBtn {
            border: 1px solid #008cff;
            padding: 3px 12px;
            border-radius: 5px;
            color: #008cff;
            cursor: pointer;
            font-weight: 500;
            &:hover {
              background-color: #008cff;
              color: #fff;
            }
          }
        }
        /deep/.el-textarea {
          z-index: 99;
          textarea {
            max-height: 450px;
          }
        }
      }
      .seldate {
        margin: 0 15px;
        .el-input__inner {
          flex: 1;
        }
        .el-input__inner {
          width: 100%;
        }
        .el-date-editor/deep/.el-range-separator {
          width: 16px;
          padding: 0;
        }
      }
      .selects {
        padding: 0 10px;
        .el-select {
          flex: 1;
        }
        // /deep/.el-select__tags {
        //   height: 26px;
        //   overflow: auto;
        //   &::-webkit-scrollbar {
        //     width: 12px;
        //   }
        //   &::-webkit-scrollbar-track {
        //     background-color: rgba(0, 1, 0, 0);
        //   }
        //   &::-webkit-scrollbar-thumb {
        //     background-color: rgba(0, 0, 0, 0.2);
        //   }
        // }
      }
      .btn {
        font-size: 14px;
        align-items: center;
        .b1 {
          margin-right: 15px;
          cursor: pointer;
          font-weight: 500;
          color: #008cff;
          line-height: 20px;
          &:hover {
            color: #008cffa6;
          }
        }
        .b2 {
          width: 60px;
          height: 32px;
          line-height: 32px;
          background: linear-gradient(270deg, #1a9dff 0%, #1a5eff 100%);
          box-shadow: 0px 8px 20px -6px rgba(26, 94, 255, 0.5);
          border-radius: 4px;
          margin-right: 16px;
        }
      }
    }
    .main {
      height: 100%;
      /* padding: 24px 0 0 0px;*/
      display: flex;
      flex-direction: column;
      margin-top: 5px;
      background-color: #fff;
      border-radius: 4px;
      overflow: auto;
      .tableTiele {
        padding-left: 24px;
        font-size: 14px;
        font-weight: 600;
        color: #008cff;
        text-align: left;
        position: relative;
        .setup {
          cursor: pointer;
          display: inline-block;
          &:hover {
            color: #008cffaa;
          }
        }
        .titName {
          height: 242px;
          width: 234px;
          border-radius: 4px;
          border: 1px solid #ccc;
          position: absolute;
          top: 26px;
          left: 24px;
          z-index: 1011;
          background-color: #fff;
          padding: 8px;
          overflow: auto;
          .el-checkbox-group {
            overflow: auto;
          }
          .el-checkbox {
            width: 100%;
            margin: 4px 0;
          }
        }
      }
      .tables {
        height: 100%;
        margin-top: 22px;
        padding-left: 24px;
        overflow: hidden;
        flex: 1;
        overflow: auto;
        min-width: 900px;
        /deep/.el-table {
          .el-table__fixed,
          .el-table__fixed-right {
            top: 0px;
            height: calc(100% - 20px) !important;
            background-color: #fff;
          }
          // .el-table__cell{height: 56px}
          .el-table__fixed-body-wrapper {
            top: 48px !important;
            height: calc(100% - 70px) !important;
          }
          .el-table__body-wrapper {
            height: calc(100% - 60px) !important;
          }
        }
        .altitude {
          line-height: 31px;
        }
      }
      .bottom {
        height: 32px;
        margin: 3px 0 10px 0;
      }
    }
  }
  .bottom {
    padding-left: 20px;
    text-align: left;
  }
  .no-data {
    width: 100%;
    margin-top: 150px;
  }
}
  /deep/.el-table__fixed-right-patch {
    height: 49px !important;
  }
/*.el-table__row{
  border-top: 1px solid #ebeef5;

}*/
#outPut > button {
  width: 60px;
  margin-right: 40px;
  background: linear-gradient(270deg, #1a9dff 0%, #1a5eff 100%);
  box-shadow: 0px 8px 20px -6px rgba(26, 94, 255, 0.5);
  border-radius: 4px;
}

</style>